export function renderBuildAuthorshipAliasBlockCreatedByUserTemplate(): string {
  return `const createdByUser = alias(user, 'created_by_user')
const updatedByUser = alias(user, 'updated_by_user')`
}
